import type { AdapterMeta } from "@repo/adapter-core";

export const RAY_WHITE_META: AdapterMeta = {
  slug: "ray-white",
  name: "Ray White",
  baseUrl: "https://www.raywhite.com",
  description: "Australia's largest real estate group with national sold property coverage.",
  supportedStates: ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"],
  // Per-office detail page: /properties/sold-residential/<state>/<suburb-postcode>/<type>/<id>
  // Match any raywhite*.com.au or raywhite*.co.nz subdomain that uses the
  // dynamics.net CMS pattern.
  urlPattern:
    /https?:\/\/[a-z0-9-]*raywhite[a-z0-9-]*\.com(?:\.au)?\/properties\/sold-residential\/[a-z]{2,3}\/[a-z0-9-]+\/[a-z-]+\/\d+/i,
  sourceType: "agency",
};
